import { ROUTES } from "routing/routes";

export const PARENT_PRECONNECTED_SIGN_IN_CALLBACK_URL = `${window.location.origin}${ROUTES.SIGN_IN_PARENT_VIA_LINK.buildPath(
  {},
  {
    pageReferrer: ROUTES.SIGN_UP_PARENT.buildPath({})
  }
)}`;

export const COUNTDOWN_SECONDS = 60;
